'use client'

import { Fieldset, Modal as MantineModal, Title, useMatches } from '@mantine/core'
import type { ComponentProps } from 'react'

type Props = ComponentProps<typeof MantineModal> & {
	title: string
}

export function Modal({ opened, onClose, title, children }: Props) {
	// makes modal occupies full screen on mobile
	const fullScreen = useMatches({
		base: true,
		md: false,
	})

	return (
		<MantineModal size="xl" opened={opened} onClose={onClose} fullScreen={fullScreen} withCloseButton>
			<Fieldset
				bg="white"
				styles={{
					legend: { marginLeft: 'auto', marginRight: 'auto' },
					root: { borderColor: 'white' },
				}}
				legend={<Title>{title}</Title>}
				style={{ whiteSpace: 'pre-wrap' }}
				className="text-black text-lg"
			>
				{children}
			</Fieldset>
		</MantineModal>
	)
}
